/**
 * Prebuilt kit size picker — Shop All, Offers, and other kit cards.
 */
(function () {
  'use strict';

  var picker = document.querySelector('[data-kit-picker]');
  if (!picker) return;

  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var moneyFormat =
    picker.getAttribute('data-money-format') ||
    (window.Shopify && window.Shopify.money_format) ||
    '₹{{amount}}';

  var mediaEl = picker.querySelector('[data-kit-picker-media]');
  var titleEl = picker.querySelector('[data-kit-picker-title]');
  var contentsEl = picker.querySelector('[data-kit-picker-contents]');
  var optionsEl = picker.querySelector('[data-kit-picker-options]');
  var priceEl = picker.querySelector('[data-kit-picker-price]');
  var compareEl = picker.querySelector('[data-kit-picker-compare]');
  var saveEl = picker.querySelector('[data-kit-picker-save]');
  var addBtn = picker.querySelector('[data-kit-picker-add]');

  var pending = null;
  var selected = {};

  function formatMoney(cents) {
    cents = Number(cents) || 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents, moneyFormat);
      } catch (e) {
        /* fall through */
      }
    }
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '₹' + parts.join('.');
  }

  function saveLabel(price, compareAt) {
    if (!compareAt || compareAt <= price) return '';
    return 'SAVE ' + Math.round(((compareAt - price) / compareAt) * 100) + '%';
  }

  function parseJson(el) {
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function sizeDisplayName(value) {
    var key = String(value || '').trim();
    var map = {
      S: 'Small',
      Small: 'Small',
      M: 'Medium',
      Medium: 'Medium',
      L: 'Large',
      Large: 'Large',
      XL: 'X-Large',
      'X-Large': 'X-Large',
      'X Large': 'X-Large',
      'Extra Large': 'X-Large',
      XXL: 'XXL',
      '2XL': 'XXL',
      '2X': 'XXL',
      XXXL: 'XXXL',
      '3XL': 'XXXL',
      '3X': 'XXXL',
      '4XL': '4XL',
      '4X': '4XL'
    };
    return map[key] || key;
  }

  function optionValues(option) {
    return (option && option.values) || [];
  }

  function looksLikeDisposableSize(option) {
    var n = String((option && option.name) || '').toLowerCase();
    if (n.indexOf('disposable') !== -1 || n.indexOf('use-throw') !== -1 || n.indexOf('use and throw') !== -1) {
      return true;
    }
    return optionValues(option).some(function (value) {
      return String(value).indexOf('/') !== -1;
    });
  }

  function isKitSizeOption(option) {
    var n = String((option && option.name) || '').toLowerCase();
    if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) return false;
    if (n.indexOf('size') !== -1 || n.indexOf('panty') !== -1 || n.indexOf('underwear') !== -1 || n.indexOf('waist') !== -1) {
      return true;
    }
    return looksLikeDisposableSize(option);
  }

  function kitOptionCopy(option, product) {
    if (looksLikeDisposableSize(option)) {
      return {
        label: 'Disposable panty size',
        hint: 'This size is for the disposable period panties in this kit.'
      };
    }
    return {
      label: (product && product.sizeFor) || 'Reusable panty size',
      hint: (product && product.sizeHint) || 'This size is for the reusable underwear in this kit — Mid waist, Black.'
    };
  }

  function findVariant(variants, selectedOptions) {
    var keys = Object.keys(selectedOptions);
    if (!keys.length) return null;
    return (variants || []).find(function (variant) {
      return keys.every(function (key) {
        return !selectedOptions[key] || variant[key] === selectedOptions[key];
      });
    });
  }

  function allSizesChosen(product) {
    if (!product || !product.options || !product.options.length) return true;
    return product.options.every(function (option) {
      if (!isKitSizeOption(option)) return true;
      return Boolean(selected['option' + option.position]);
    });
  }

  function currentVariant() {
    if (!pending) return null;
    if (!allSizesChosen(pending)) return null;
    return findVariant(pending.variants, selected);
  }

  function displayVariant() {
    return currentVariant() || (pending && pending.variants && pending.variants[0]) || null;
  }

  function updatePrice() {
    var variant = displayVariant();
    var chosen = currentVariant();
    if (!variant || !priceEl) return;

    priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
    if (saveEl) {
      var label = saveLabel(variant.price, variant.compare_at_price);
      saveEl.textContent = label;
      saveEl.hidden = !label;
    }

    if (addBtn) {
      if (!chosen) {
        addBtn.disabled = true;
        addBtn.textContent = 'Select size';
      } else if (!chosen.available) {
        addBtn.disabled = true;
        addBtn.textContent = 'Back soon';
      } else {
        addBtn.disabled = false;
        addBtn.textContent = 'Add kit';
      }
    }

    if (mediaEl && chosen && chosen.image) {
      mediaEl.innerHTML = '<img src="' + chosen.image + '" alt="">';
    }
  }

  function parseContents(raw) {
    if (Array.isArray(raw)) {
      return raw
        .map(function (item) {
          return String(item || '').trim();
        })
        .filter(Boolean);
    }
    return String(raw || '')
      .split('|')
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);
  }

  function renderContents(raw) {
    if (!contentsEl) return;
    var items = parseContents(raw);
    contentsEl.innerHTML = '';
    if (!items.length) {
      contentsEl.hidden = true;
      return;
    }

    var label = document.createElement('span');
    label.className = 'fabpad-kit-picker__contents-label';
    label.textContent = "What's included";
    contentsEl.appendChild(label);

    var wrap = document.createElement('div');
    wrap.className = 'fabpad-kit-picker__contents-chips';
    items.forEach(function (text) {
      var chip = document.createElement('span');
      chip.className = 'fabpad-kit-picker__item';
      chip.textContent = text;
      wrap.appendChild(chip);
    });
    contentsEl.appendChild(wrap);
    contentsEl.hidden = false;
  }

  function open(product) {
    pending = product;
    selected = {};

    if (titleEl) titleEl.textContent = product.title || '';
    if (mediaEl) {
      var img = product.image || '';
      mediaEl.innerHTML = img ? '<img src="' + img + '" alt="">' : '';
    }
    renderContents(product.contents);

    if (optionsEl) {
      optionsEl.innerHTML = '';
      (product.options || []).forEach(function (option) {
        var copy = isKitSizeOption(option) ? kitOptionCopy(option, product) : { label: option.name, hint: '' };
        var group = document.createElement('div');
        group.className = 'fabpad-kit-picker__group';

        var label = document.createElement('span');
        label.className = 'fabpad-kit-picker__group-label';
        label.textContent = copy.label;
        group.appendChild(label);

        if (copy.hint) {
          var hint = document.createElement('p');
          hint.className = 'fabpad-kit-picker__hint';
          hint.textContent = copy.hint;
          group.appendChild(hint);
        }

        var chips = document.createElement('div');
        chips.className = 'fabpad-kit-picker__chips';
        var key = 'option' + option.position;

        optionValues(option).forEach(function (value) {
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'fabpad-kit-picker__chip';
          chip.textContent = looksLikeDisposableSize(option) ? value : sizeDisplayName(value);
          chip.setAttribute('data-option-value', value);
          chip.addEventListener('click', function () {
            selected[key] = value;
            chips.querySelectorAll('.fabpad-kit-picker__chip').forEach(function (el) {
              el.classList.toggle('is-active', el.getAttribute('data-option-value') === value);
            });
            updatePrice();
          });
          chips.appendChild(chip);
        });

        group.appendChild(chips);
        optionsEl.appendChild(group);
      });
    }

    updatePrice();
    picker.hidden = false;
    document.body.classList.add('fabpad-kit-picker-open');
  }

  function close() {
    picker.hidden = true;
    document.body.classList.remove('fabpad-kit-picker-open');
    pending = null;
    selected = {};
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = 'Select size';
    }
  }

  function readCard(card) {
    return {
      id: card.getAttribute('data-product-id'),
      title: card.getAttribute('data-title') || (card.querySelector('[data-card-product-link]') || {}).textContent || '',
      image: card.getAttribute('data-product-image') || '',
      sizeFor: card.getAttribute('data-size-for') || '',
      sizeHint: card.getAttribute('data-size-hint') || '',
      contents: card.getAttribute('data-kit-contents') || '',
      options: parseJson(card.querySelector('[data-product-options]')),
      variants: parseJson(card.querySelector('[data-product-variants]'))
    };
  }

  function addToCart(variant) {
    if (!addBtn || !variant) return;
    addBtn.disabled = true;
    var original = 'Add kit';
    addBtn.textContent = 'Adding…';

    fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variant.id), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add failed');
        return res.json();
      })
      .then(function (data) {
        if (window.FabpadCart && typeof window.FabpadCart.afterAdd === 'function') {
          return window.FabpadCart.afterAdd(data);
        }
        return data;
      })
      .then(function () {
        close();
      })
      .catch(function () {
        addBtn.textContent = 'Try again';
        addBtn.disabled = false;
        setTimeout(function () {
          addBtn.textContent = original;
        }, 1200);
      });
  }

  picker.addEventListener('click', function (event) {
    if (event.target.closest('[data-kit-picker-close]')) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !picker.hidden) close();
  });

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var variant = currentVariant();
      if (!variant || !variant.available) return;
      addToCart(variant);
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest('[data-kit-picker]')) return;
      var card = event.target.closest('[data-kit-card]');
      if (!card) return;
      event.preventDefault();
      event.stopPropagation();
      open(readCard(card));
    },
    true
  );

  window.FabpadKitPicker = {
    open: open,
    close: close
  };
})();
